/**
 * As duas caixas de marcar dos cadastros do combustível — "tanque padrão" e
 * "Disponível" (desmarcar arquiva) — entre a linha gravada, o formulário e o
 * envio.
 *
 * Elas não são campos de texto e por isso não moram na lista de campos do
 * formulário, que as desenha à parte. O defeito estava exatamente aí: abrir a
 * edição só carregava os campos da lista, então a caixa nascia sempre
 * "Disponível" e nunca "padrão", mesmo no cadastro arquivado ou no tanque
 * padrão; e o envio só levava os campos da lista, então marcar ou desmarcar
 * não gravava nada. O servidor aceita as duas como booleano
 * (`backend/src/rotas/combustivel-cadastros.ts`).
 *
 * O formulário guarda tudo como texto, e as caixas vão como `'true'` e
 * `'false'` — é o que a tela já lia: `ativo !== 'false'`, `padrao === 'true'`.
 */

/** O que a linha gravada tem das duas caixas. Posto e produto não têm padrão. */
export interface LinhaComCaixas {
  readonly ativo?: boolean;
  readonly padrao?: boolean;
}

/** A linha gravada -> o estado das caixas no formulário de edição. */
export function caixasDaLinha(linha: LinhaComCaixas, temPadrao: boolean): Record<string, string> {
  return {
    ativo: String(linha.ativo !== false),
    ...(temPadrao ? { padrao: String(linha.padrao === true) } : {}),
  };
}

/**
 * O estado das caixas -> o que vai no envio, como booleano.
 *
 * `padrao` só no tanque, que é o único que o tem. `ativo` só na edição: o
 * cadastro novo nasce disponível, e a caixa nem aparece nele.
 */
export function caixasDoEnvio(
  valores: Readonly<Record<string, string>>,
  { temPadrao, editando }: { readonly temPadrao: boolean; readonly editando: boolean },
): Record<string, boolean> {
  return {
    ...(temPadrao ? { padrao: valores['padrao'] === 'true' } : {}),
    ...(editando ? { ativo: valores['ativo'] !== 'false' } : {}),
  };
}
